import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import type { IRootState } from '../..';
import type { IFileResponse } from '../../../dtm/types';
import { primeApi } from '../../../lib/api/prime';
import * as actions from './actions';

const ActionTypes = actions.ActionTypes;

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const getLastListingCursor = (state: IRootState) => state.dtm.properties.lastListingCursor;
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const getLastSalesCursor = (state: IRootState) => state.dtm.properties.lastSalesCursor;
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const getListingEnd = (state: IRootState) => state.dtm.properties.listingEnd;
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const getSalesEnd = (state: IRootState) => state.dtm.properties.salesEnd;

export function* handleFetchProperties(action: ReturnType<typeof actions.fetchProperties>) {
  try {
    const lastListingCursor: string = yield select(getLastListingCursor);
    const lastSalesCursor: string = yield select(getLastSalesCursor);
    const listingEnd: boolean = yield select(getListingEnd);
    const salesEnd: boolean = yield select(getSalesEnd);
    const searchValue = action.payload.searchValue;
    const sortAsc = action.payload.sortAsc;
    const searchType = action.payload.searchType;
    if (salesEnd && listingEnd) {
      yield put(actions.endOfPropertiesReached());
    } else {
      const res: IFileResponse = yield call(primeApi.getFiles, {
        lastListingCursor,
        lastSalesCursor,
        listingEnd,
        salesEnd,
        searchValue,
        sortAsc,
      });
      yield put(actions.fetchPropertiesDone(res, res.lastSalesCursor, res.lastListingCursor, searchType));
    }
  } catch {
    console.info('Error fetching properties');
  }
}

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_PROPERTIES, handleFetchProperties)]);
}
